import { useEffect, useState } from "react";
import ImageRoundedIcon from "@mui/icons-material/ImageRounded";
import { Box } from "@mui/material";
import { getProductImage, getProductVariantImage } from "../api/products";

export default function PosProductImage({ product }) {
  const [url, setUrl] = useState("");
  useEffect(() => {
    if (!product?.has_image || !product?.product_public_id) return undefined;
    let cancelled = false;
    let objectUrl = "";
    const request = product.image_variant_public_id
      ? getProductVariantImage(product.product_public_id, product.image_variant_public_id)
      : getProductImage(product.product_public_id);
    request.then((response) => {
      if (cancelled) return;
      objectUrl = URL.createObjectURL(response.data);
      setUrl(objectUrl);
    }).catch(() => {
      if (!cancelled) setUrl("");
    });
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [product?.has_image, product?.product_public_id, product?.image_variant_public_id]);

  return (
    <Box sx={{ width: { xs: "100%", sm: 108 }, height: { xs: 150, sm: 90 }, flexShrink: 0, borderRadius: 2, overflow: "hidden", bgcolor: "#eff6ff", display: "grid", placeItems: "center" }}>
      {url ? (
        <Box component="img" src={url} alt={product.product_name} onError={() => setUrl("")} sx={{ width: "100%", height: "100%", objectFit: "cover" }} />
      ) : (
        <ImageRoundedIcon aria-label="No product image" sx={{ fontSize: 34, color: "#94a3b8" }} />
      )}
    </Box>
  );
}
